/* eslint-disable */
import BreadCrumb from 'components/BreadCrumb';
import React,{ useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import ButtonV2 from 'components/ButtonV2';
import ButtonNoBorder from 'components/ButtonNoBorder';
import ButtonSecondary from 'components/ButtonSecondary';
import DropdownV3 from 'components/DropdownV3';
import { dataCategory,listLanguage, opsiHeader, opsiButton, TypeCTA, TypeQuickReply, UrlTypeCTA, categoryTemplate } from 'containers/NewWaTemplate/ListDropdownData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import _ from 'lodash';
import Modal from "react-modal";
import { Alert, AlertType } from "utils/Alert";

import { listDomain } from 'utils/listDomain';

// Library
import FeatherIcon from 'feather-icons-react';

// components
import PhoneMediaPreview from "./PhoneMediaPreview"

// services
import applicationSvc from "services/applicationSvc";
import waTemplateSvc from "services/waTemplateSvc";

// style
import './FormCreateTemplate.scss';
import '../whatsappTemplate.scss';
import styled from "styled-components";

// image
import AlertTriangle from '_assets/svg/alert-triangle.svg';
import InputDropdown from 'components/InputDropdown';
import AddButtonTemplate from './AddButtonTemplate';

function ContentTemplate(props) {
  const {
    isIndexPage,
    isPreview,
    isChooseTypeTemplate,
    location,
    handleSelectLanguage,
    isSelectNewLanguage,
    handleSelectHeader,
    isOptionMedia,
    handleHeader,
    setOnBlurHeaderText,
    addVariableHeaderText,
    isDisableInputHeader,
    setBodyMessage,
    setNewTextOnBlur,
    addEmoji,
    handleInsertSymbol,
    isCountVariable,
    handleAaddVariable,
    handleFooter,
    handlesetOptionButtons, 
    handleDropdownType, 
    setChangeButtonOptions, 
    deleteTypeQuickReply, 
    handleAddOtherButton,
    handleOptionPhoneNumber,
    handleDropdownUrlType,
    isSelectedLanguage,
    texAreaRef,
    isOptionButtons,
    toggleEmojiPicker,
    showEmojiPicker,
    isFooterMessage,
    isHeaderPhone,
    inputTextHeader,
    isErrorButtonText,
    listPhoneNumber,
    isOptionPhoneNumber,
    isErrorUrl,
    isVarDynamicWeb,
    onSwitchSection,
    setHeaderPreview,
    isSelectedAccount
  } = props;
  
  return (
    <div className='content'>
    {isChooseTypeTemplate && isChooseTypeTemplate.map((val, idx) =>{
    return (
      <div key={idx} className={`${idx === isIndexPage ? 'active' : 'd-none'} row form-fields justify-content-between`}>
        <div className="col-xl-8 col-md-7 pr-xl-4">
          <div className='row'>
            <div className='col-3 d-none'>
              <div className='wrapper_language'>
                <p className='fsize-14 cl-neutral400 fweight-600'>Languages</p>
                {location?.state?.dataChooseTypeTemplate.edit &&
                  <div>
                    <button className={`button_language ${'active'}`}>{isSelectedLanguage?.name}</button>
                  </div>
                }
                {!location?.state?.dataChooseTypeTemplate.edit &&
                  <div>
                  {isChooseTypeTemplate?.length > 0 && isChooseTypeTemplate.map((item, index) => {
                    return(
                      <button onClick={()=>openRoomByLanguage(item, index)} key={index} className={`button_language ${isSelectedLanguage.name === item.name && 'active'}`}>{item.name}</button>
                    )
                  })}
                  </div>
                }
                  <DropdownV3 
                    useSearch
                    className={`padding_language ${location?.state?.dataChooseTypeTemplate.edit && 'd-none'}`}
                    isListSearch={listLanguage} 
                    setSelectedSearch={handleSelectLanguage} 
                    isSelected={isSelectNewLanguage.name}
                    placeholder="Choose language"
                  />
              </div>
            </div>
            <div className='col-12'>
              {location?.state?.dataChooseTypeTemplate.status === 'REJECTED' && 
                <div className='alert_rejected_template mb-3'>
                  <div className='d-flex align-items-center mb-2'>
                    <FeatherIcon icon="info" />
                    <span className='fsize-16 fweight-600 cl-red ms-2'>This template has been rejected</span>
                  </div>
                  <p className='fsize-14 fweight-400 cl-neutral500'>This template contains content that does not comply with WhatsApp's policies. You can edit the template and re-submit for review. Or if you believe that this is incorrect, you can request a review in Account Quality. We recommend adding a sample before submitting.  
                    <a href='https://developers.facebook.com/docs/whatsapp/message-templates/guidelines' target='_blank' className='cl-red'> Learn More.</a>
                  </p>
                </div>
              }
              <div>
                <div className="wrapper_input_template mb-4 position-relative">
                  <div className="d-flex align-items-center mb-2">
                    <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Header</h4>
                    <div className="optional ms-2 cl-neutral300 fweight-600 fsize-12">Optional</div>
                  </div>
                  <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                    Add a title or choose which type of media you'll use for this header.
                  </div>
                  <div className="d-flex align-items-start">
                    <div className="me-4">
                      <DropdownV3
                        isListSearch={opsiHeader} 
                        setSelectedSearch={(value)=>handleSelectHeader(value,idx, 'HEADER')} 
                        isSelected={isOptionMedia}
                        placeholder="None"
                      />
                    </div>
                    {/* header text */}
                    {val.dataStructure.header[0].format === "TEXT" && (
                      <div className="w-100 wrapper_input_count">
                        <div className="input-group">
                          <input
                            ref={inputTextHeader}
                            required={true}
                            // defaultValue={val.dataStructure.header[0].text}
                            value={val?.dataStructure?.header[0]?.text?.body ? 
                              val?.dataStructure?.header[0]?.text?.body : 
                              val?.dataStructure?.header[0]?.text
                            }
                            onChange={(e) => handleHeader({ type: "text", text: e.target.value, idx: idx })}
                            onBlur={(e)=>setOnBlurHeaderText({ type: "text", text: e.target.value, idx: idx })}
                            type="text"
                            placeholder="Enter text here"
                            error=""
                            className="form-control cl-neutral100"
                            maxLength={60}
                          />
                          <span className="count-char">{val.dataStructure.header[0].text.length ? val.dataStructure.header[0].text.length : 0}/60</span>
                        </div>
                        <div className='d-flex align-items-center justify-content-end mt-2 d-none'>
                          <ButtonNoBorder
                            handleRoute={()=>addVariableHeaderText('{{1}}', idx)} 
                            disabled={isDisableInputHeader}
                            backgroundColor="#ffffff"
                            textColor="#42526E"
                            padding=".360rem 1rem"
                            className={`
                            ${val?.dataStructure?.header[0]?.text?.body ? val?.dataStructure?.header[0]?.text?.body?.includes('{{1}}') :''
                            
                            && 'event_disable'}  fsize-12`}
                          >
                            + Add Variable
                            <OverlayTrigger
                              placement="right"
                              overlay={<Tooltip id="button-tooltip-2">This is text that you specify in the API that will be personalised to the customer, such as their name or invoice number.</Tooltip>}
                            >
                              <span className='d-flex'>
                                <FeatherIcon icon="info" className="cursor-pointer cl-black ms-2" />
                              </span>
                            </OverlayTrigger>
                          </ButtonNoBorder>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* mediaa */}
                  {val?.dataStructure?.header[0]?.label === 'media' && (
                    <div className="row mt-2">
                      <div className="col-xl-3 col-6">
                        <div
                          className={`${val.dataStructure.header[0].format === "IMAGE" ? "opsi-media choosen" : "opsi-media"} opsi-media`}
                        >
                          <div className="bullet-circle"></div>
                          <input
                            type="radio"
                            name="media"
                            value={isHeaderPhone.type}
                            onChange={(e) =>
                              handleHeader({ type: "image", text: "", image: { link: "" }, idx })
                            }
                          />
                          <div className="icon-media">
                            <svg
                              width="72"
                              height="72"
                              viewBox="0 0 72 72"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M57 9H15C11.6863 9 9 11.6863 9 15V57C9 60.3137 11.6863 63 15 63H57C60.3137 63 63 60.3137 63 57V15C63 11.6863 60.3137 9 57 9Z"
                                stroke="#B3BAC5"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M25.5 30C27.9853 30 30 27.9853 30 25.5C30 23.0147 27.9853 21 25.5 21C23.0147 21 21 23.0147 21 25.5C21 27.9853 23.0147 30 25.5 30Z"
                                stroke="#B3BAC5"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M63 45L48 30L15 63"
                                stroke="#B3BAC5"
                                strokeWidth="4"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                className="fill"
                                d="M16.5 62L48 30L62.5 44.5V62H16.5Z"
                                fill="#B3BAC5"
                              />
                            </svg>
                            <span className="label-media">Image</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-6">
                        <div
                          className={`${val.dataStructure.header[0].format === "VIDEO" ? "opsi-media choosen" : "opsi-media"} opsi-media`}
                        >
                          <div className="bullet-circle"></div>
                          <input
                            type="radio"
                            name="media"
                            value={isHeaderPhone.type}
                            onChange={(e) =>
                              handleHeader({ type: "video", text: "", video: { link: "" }, idx })
                            }
                          />
                          <div className="icon-media">
                            <svg
                              width="72"
                              height="72"
                              viewBox="0 0 72 72"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle className="fill" cx="36" cy="36" r="27" fill="#B3BAC5" />
                              <path
                                d="M46.5 35.134C47.1667 35.5189 47.1667 36.4811 46.5 36.866L31.5 45.5263C30.8333 45.9112 30 45.4301 30 44.6603L30 27.3397C30 26.5699 30.8333 26.0888 31.5 26.4737L46.5 35.134Z"
                                fill="white"
                              />
                            </svg>
                            <span className="label-media">Video</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-6 mt-xl-0 mt-3">
                        <div
                          className={`${val.dataStructure.header[0].format === "DOCUMENT" ? "opsi-media choosen" : "opsi-media"
                            }`}
                        >
                          <div className="bullet-circle"></div>
                          <input
                            type="radio"
                            name="media"
                            value={isHeaderPhone.type}
                            onChange={(e) =>
                              handleHeader({ type: "document", text: "", document: { link: "" }, idx })
                            }
                          />
                          <div className="icon-media">
                            <svg
                              width="72"
                              height="72"
                              viewBox="0 0 72 72"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                className="fill"
                                x="13"
                                y="9"
                                width="46"
                                height="54"
                                rx="5"
                                fill="#B3BAC5"
                              />
                              <rect x="19" y="17" width="34" height="4" rx="2" fill="white" />
                              <rect x="19" y="26" width="34" height="4" rx="2" fill="white" />
                              <rect x="19" y="35" width="27" height="4" rx="2" fill="white" />
                            </svg>
                            <span className="label-media">Document</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="mb-4 position-relative wrapper_body">
                  <h4 className="cl-neutral400 fweight-700 fsize-14 mb-2">Body</h4>
                  <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                    Enter the text for your message in the language you've selected.
                  </div>
                  <div className="w-100 wrapper_count_textarea">
                    <div className="form-group">
                      {/* <span className="length_count">{val.dataStructure.body[0].text?.length ? val.dataStructure.body[0].text?.length : 0}/1024</span> */}
                      <textarea
                        name={`body_${idx}`}
                        ref={texAreaRef}
                        required={true}
                        type="text"
                        placeholder="Enter text..."
                        value={val.dataStructure.body[0].text}
                        onChange={(e) => setBodyMessage(e.target.value, idx)}
                        onBlur={(e) => setNewTextOnBlur(e.target.value, idx)}
                        error=""
                        className={`form-control cl-neutral500 fweight-400 fsize-14`}
                        rows={7}
                        // maxLength={1024}
                        maxlength="1024"
                      />
                    </div>
                    <div className="form-group mt-3 mb-md-2 mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <span className="count_text"> Characters: {val.dataStructure.body[0].text?.length}/1024</span>
                        </div>
                        <div className="d-flex align-items-center wrapper_icon">
                          {/* <img onClick={()=>handleInsertSymbol('*')} src={IconImage} className="ms-3 btn-editor"></img> */}
                          <div className='wrapp_emoji postion-relative d-flex'>
                            <FeatherIcon onClick={toggleEmojiPicker} width={13} height={13} icon="smile" />
                            {showEmojiPicker &&
                              <div className='add_emoji'>
                                <Picker data={data} onEmojiSelect={(event)=>addEmoji(event, idx)} />
                              </div>
                            }
                          </div>
                          <FeatherIcon onClick={() => handleInsertSymbol("*", idx)} className="ms-2" width={13} height={13} icon="bold" />
                          <FeatherIcon onClick={() => handleInsertSymbol("_", idx)} className="ms-2" width={13} height={13} icon="italic" />
                          <FeatherIcon onClick={() => handleInsertSymbol("~", idx)} className="ms-2" width={13} height={13} icon="dollar-sign" />
                          {/* <Icon onClick={() => handleInsertSymbol("```", idx)} src={Svg.monospace.default} alt="monospace" className='monospace ms-2' /> */}
                          {/* <img
                            onClick={() => handleInsertSymbol("*")}
                            src={Boldmage}
                            className="ms-3 btn-editor"
                          ></img>
                          <img
                            onClick={() => handleInsertSymbol("_")}
                            src={ItalicImage}
                            className="ms-3 btn-editor"
                          ></img> */}
                          <div onClick={() => handleAaddVariable(isCountVariable, idx)} className="add_variable ms-2 d-flex align-items-center">
                            <FeatherIcon className="cl-light-grey pinkic-hover me-1" icon="plus" />
                              Add Variable
                          </div>
                          <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="button-tooltip-2">This is text that you specify in the API that will be personalised to the customer, such as their name or invoice number.</Tooltip>}
                            >
                              <span className='ic_info d-flex align-items-center ms-2'>
                                <FeatherIcon className="cl-light-grey pinkic-hover" icon="info" />
                              </span>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wrapper_input_template mb-4 position-relative">
                  <div className="d-flex align-items-center mb-2">
                    <h4 className="cl-neutral400 fweight-700 fsize-14 mb-0">Footer</h4>
                    <div className="optional ms-2 cl-neutral300 fweight-600 fsize-12">Optional</div>
                  </div>
                  <div className="cl-neutral100 mb-2 fsize-12 fweight-400">
                    Add a short line of text to the bottom of your message template.
                  </div>
                  <div className="w-100 wrapper_count_textarea">
                    <div className="form-group">
                      <div className="w-100 wrapper_input_count">
                        <input
                          required={true}
                          defaultValue={
                            val?.dataStructure?.footer[0]?.text?.body ? 
                            val?.dataStructure?.footer[0]?.text?.body :
                            val?.dataStructure?.footer[0]?.text
                          }
                          onChange={(e) => handleFooter({ type: "text", text: e.target.value, idx: idx })}
                          type="text"
                          placeholder="Enter text here"
                          error=""
                          className="form-control cl-neutral100"
                          maxLength={60}
                        />
                        <span className="count-char">{isFooterMessage.text?.length ? isFooterMessage.text?.length : 0}/60</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Button */}
                {isChooseTypeTemplate && (
                  <AddButtonTemplate
                    handlesetOptionButtons={handlesetOptionButtons}
                    handleDropdownType={handleDropdownType}
                    setChangeButtonOptions={setChangeButtonOptions}
                    deleteTypeQuickReply={deleteTypeQuickReply}
                    handleAddOtherButton={handleAddOtherButton}
                    handleOptionPhoneNumber={handleOptionPhoneNumber}
                    handleDropdownUrlType={handleDropdownUrlType}
                    isOptionButtons={isOptionButtons}
                    isChooseTypeTemplate={isChooseTypeTemplate}
                    isErrorButtonText={isErrorButtonText}
                    listPhoneNumber={listPhoneNumber}
                    isOptionPhoneNumber={isOptionPhoneNumber}
                    isErrorUrl={isErrorUrl}
                    isVarDynamicWeb={isVarDynamicWeb}
                    onSwitchSection={onSwitchSection}
                    setHeaderPreview={setHeaderPreview}
                    isSelectedAccount={isSelectedAccount}
                    val={val}
                    idx={idx}
                    />
                )}
                <div className='d-flex justify-content-between mb-3'>
                  <div className={`d-none ${isIndexPage === 0 && 'd-none'}`}>
                  <ButtonV2 
                    handleRoute={()=>PrevPage(val,idx)}
                    disabled
                    backgroundColor="#3B3B47"
                    textColor="#FFFFFF"
                    padding=".360rem 1rem"
                    className=""
                  >
                      Previous
                  </ButtonV2>
                </div>
                  <div className={`d-none ${isIndexPage === isChooseTypeTemplate.length - 1 && 'd-none'}`}>
                    <ButtonV2 
                      handleRoute={()=>nextPage(val,idx)}
                      disabled
                      backgroundColor="#3B3B47"
                      textColor="#FFFFFF"
                      padding=".360rem 1rem"
                      className=""
                    >
                        Next Language
                    </ButtonV2>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-md-5 pr-0">
          <PhoneMediaPreview 
            onPreview={isPreview} 
            chooseData={isChooseTypeTemplate} 
            isIndexPage={isIndexPage} 
            className="sticky">
          </PhoneMediaPreview>
        </div>
      </div>
    )
    })}
  </div>
  )
}

export default ContentTemplate